module.exports = __webpack_public_path__ + "src/img/index_menu/8.png?dbea9ebad5c0f00abb7bdc5e18624d88";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/8.png
// module id = 181
// module chunks = 0